import React from 'react';

export const DropdownIndicatorIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="8"
        viewBox="0 0 10 8"
        fill="none"
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.323.335A.736.736 0 01.668.25h8.664c.369 0 .669.265.668.59a.539.539 0 01-.096.305L5.57 7.465c-.19.279-.602.369-.918.2a.641.641 0 01-.225-.2L.096 1.146C-.094.865.007.503.323.335z"
        />
    </svg>
);
